/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ClaimApiConfiguration } from '../claim-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ClmClaimDocumentsResponseDto } from '../models/clm-claim-documents-response-dto';


/**
 * the ClaQueryReadDocument API
 */
@Injectable({
  providedIn: 'root',
})
export class ClaQueryReadDocumentService extends BaseService {
  constructor(
    config: ClaimApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation documentsList
   */
  static readonly DocumentsListPath = '/claim/{claimId}/document';

  /**
   * Get documents.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `documentsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsList$Response(params: {
    claimId: string;
    language?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ClmClaimDocumentsResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ClaQueryReadDocumentService.DocumentsListPath, 'get');
    if (params) {
      rb.path('claimId', params.claimId, {});
      rb.query('language', params.language, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ClmClaimDocumentsResponseDto>;
      })
    );
  }

  /**
   * Get documents.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `documentsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  documentsList(params: {
    claimId: string;
    language?: string;
  },
  context?: HttpContext

): Observable<ClmClaimDocumentsResponseDto> {

    return this.documentsList$Response(params,context).pipe(
      map((r: StrictHttpResponse<ClmClaimDocumentsResponseDto>) => r.body as ClmClaimDocumentsResponseDto)
    );
  }

}
